export default "__VITE_ASSET__a81c3a74__"